/* ==========================================================================
   LSF 21/09/2026 — Chargement des images dans le tiroir menu et l'overlay
   de recherche.

   Probleme : ces images portent loading="lazy" alors qu'elles se trouvent
   dans un conteneur en display:none (le tiroir burger ferme, la modale
   #lsf-sb-modal). Le navigateur repousse leur telechargement et, une fois
   le conteneur affiche, l'observateur interne ne se redeclenche pas
   toujours : les vignettes restent vides.
   Concerne : snippets/lsf-search-bar.liquid (grille par defaut + cartes
   construites en JS), sections/header.liquid (.lsf-dtiles__img) et le
   visuel #lsf-review-link injecte depuis header-group.json.

   Solution : au moment ou l'un de ces conteneurs s'ouvre, on repasse ses
   images en loading="eager" et on relance celles qui n'ont rien charge.
   Aucun fichier coeur du theme n'est modifie.
   Pour annuler : retirer la ligne 'lsf-mobile-ux.js' de layout/theme.liquid.
   ========================================================================== */
(function () {
  'use strict';

  function wake(root) {
    if (!root) return;
    var imgs = root.querySelectorAll('img[loading="lazy"], img[loading="auto"]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      img.setAttribute('loading', 'eager');
      /* naturalWidth a 0 = rien n'a ete telecharge : on reassigne la source
         pour forcer la requete maintenant que l'element est visible. */
      if (!img.complete || img.naturalWidth === 0) {
        var src = img.getAttribute('src');
        if (src) {
          img.removeAttribute('src');
          img.setAttribute('src', src);
        }
      }
    }
  }

  function wakeNow(root) {
    wake(root);
    /* Second passage : certains visuels du tiroir sont injectes par un autre
       script (bloc custom_liquid de header-group) juste apres l'ouverture. */
    window.setTimeout(function () { wake(root); }, 400);
  }

  /* --------------------------------------------------------------------
     SLIDER D'ACCUEIL : retablir la redirection des boutons.
     Le theme (sections/LSF-HERO-SLIDER.liquid) pose '.is-dragging' des le
     'pointerdown', et sa regle CSS '.is-dragging a { pointer-events:none }'
     casse le clic (voir lsf-mobile-ux.css section 7, qui la neutralise).
     Son propre garde-fou anti-glissement est du code mort : 'moved' est
     remis a 0 dans onUp() AVANT que le 'click' ne soit emis.
     On reimplemente donc le garde-fou ici : le clic n'est bloque que s'il y
     a eu un vrai deplacement (> 8 px). Le drapeau 'down' est indispensable :
     sur ordinateur 'pointermove' se declenche au simple survol, sans bouton
     enfonce, et bloquerait alors tous les clics.
     -------------------------------------------------------------------- */
  var DRAG_PX = 8;

  function heroDragGuard() {
    var vps = document.querySelectorAll('.lsf-hero__viewport');
    for (var i = 0; i < vps.length; i++) {
      (function (vp) {
        var down = false, x0 = 0, dragged = false;

        if (window.PointerEvent) {
          vp.addEventListener('pointerdown', function (e) {
            down = true; x0 = e.clientX; dragged = false;
          }, true);
          vp.addEventListener('pointermove', function (e) {
            if (down && Math.abs(e.clientX - x0) > DRAG_PX) dragged = true;
          }, true);
          vp.addEventListener('pointerup', function () { down = false; }, true);
          vp.addEventListener('pointercancel', function () {
            down = false; dragged = false;
          }, true);
        } else {
          vp.addEventListener('touchstart', function (e) {
            down = true; x0 = e.touches[0].clientX; dragged = false;
          }, { capture: true, passive: true });
          vp.addEventListener('touchmove', function (e) {
            if (down && Math.abs(e.touches[0].clientX - x0) > DRAG_PX) dragged = true;
          }, { capture: true, passive: true });
          vp.addEventListener('touchend', function () { down = false; }, true);
        }

        /* Phase de capture : on passe avant le gestionnaire du theme. */
        vp.addEventListener('click', function (e) {
          if (dragged) { e.preventDefault(); e.stopPropagation(); }
          dragged = false;
        }, true);
      })(vps[i]);
    }
  }

  function init() {
    heroDragGuard();

    /* --- Overlay de recherche --------------------------------------- */
    var modal = document.getElementById('lsf-sb-modal');
    if (modal) {
      new MutationObserver(function () {
        if (modal.classList.contains('lsf-open')) wakeNow(modal);
      }).observe(modal, { attributes: true, attributeFilter: ['class'] });

      /* Les cartes de resultats sont recreees a chaque frappe. On observe
         uniquement les ajouts de noeuds : wake() ne touche que des
         attributs, il ne peut donc pas reboucler sur cet observateur. */
      var right = document.getElementById('lsf-sb-right');
      if (right) {
        new MutationObserver(function () { wake(right); })
          .observe(right, { childList: true, subtree: true });
      }
    }

    /* --- Tiroir menu burger ------------------------------------------ */
    var det = document.querySelector('header-drawer details');
    if (det) {
      new MutationObserver(function () {
        if (det.hasAttribute('open')) wakeNow(det);
      }).observe(det, { attributes: true, attributeFilter: ['open', 'class'] });
      if (det.hasAttribute('open')) wakeNow(det);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ==========================================================================
   LSF 21/09/2026 — BON D'ACHAT : ligne de commande reelle et invisible.

   Probleme : la barre de gamification (snippets/lsf-cart-upgrade.liquid)
   annonce « 5 € en bon d'achat » a 65 € et « 15 € » a 100 €, mais cette
   promesse n'existait qu'a l'ecran du panier. Rien ne la suivait jusqu'a la
   page de paiement.

   Solution : deux vrais produits a 0 € sont ajoutes au panier des que le
   palier est atteint, et retires des qu'il ne l'est plus.
   - Page de paiement : la ligne s'affiche, le client voit sa recompense.
   - Panier et tiroir : la ligne est masquee (classe .lsf-voucher-row, voir
     lsf-mobile-ux.css section 8) et le compteur d'articles est corrige, donc
     le visuel du panier est strictement inchange.

   Les deux produits sont en statut UNLISTED cote Shopify : absents de la
   recherche, des collections et des recommandations.

   Leur prix etant 0 €, les ajouter ne modifie pas cart.total_price : le calcul
   des paliers ne peut donc pas s'auto-entretenir.

   21/09/2026 — correctif : le bon etait supprime au moment du paiement. Voir
   le bloc « Paiement » plus bas pour le detail.
   ========================================================================== */
(function () {
  'use strict';

  /* Paliers identiques a ceux de snippets/lsf-cart-upgrade.liquid.
     Si vous changez un montant, changez-le AUSSI la-bas. */
  var T1 = 6500; /* 65 €  -> bon de 5 €  */
  var T2 = 10000; /* 100 € -> bon de 15 € */

  /* Identifiants de variante des produits « Bon d'achat 5 € » / « 15 € ».
     Ils sont figes ici pour garder ce correctif dans un simple fichier
     d'assets, sans toucher au coeur du theme. S'ils changent un jour,
     mettre a jour ces deux lignes. */
  var ID1 = 58841527845199;
  var ID2 = 58841528336719;
  var IDS = [ID1, ID2];

  var busy = false;
  var timer = null;
  var pending = null; /* synchronisation en cours, attendue avant le paiement */

  function log(message, error) {
    /* Les echecs etaient avales en silence : une commande a ainsi perdu son
       bon le 21/09/2026 sans laisser la moindre trace. */
    if (window.console && console.error) console.error('[LSF bon] ' + message, error);
  }

  function isVoucher(id) {
    return id === ID1 || id === ID2;
  }

  function countOf(cart, id) {
    var n = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === id) n += cart.items[i].quantity;
    }
    return n;
  }

  /* Variante attendue dans le panier (0 = aucune). Non cumulatif : on ne garde
     que le palier le plus haut, exactement comme la barre de progression. */
  function wanted(cart) {
    var real = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (!isVoucher(cart.items[i].variant_id)) real += cart.items[i].quantity;
    }
    if (real === 0) return 0;
    if (cart.total_price >= T2) return ID2;
    if (cart.total_price >= T1) return ID1;
    return 0;
  }

  /* Masque la ligne du bon et retire les bons du compteur d'articles. */
  function paint(cart) {
    var links = document.querySelectorAll('a[href*="/products/bon-achat-"]');
    for (var i = 0; i < links.length; i++) {
      var row = links[i].closest('.cart-item');
      if (row) row.classList.add('lsf-voucher-row');
    }

    var shown = String(cart.item_count - countOf(cart, ID1) - countOf(cart, ID2));
    var bubbles = document.querySelectorAll('.cart-count-bubble');
    for (var b = 0; b < bubbles.length; b++) {
      var spans = bubbles[b].querySelectorAll('span');
      for (var s = 0; s < spans.length; s++) {
        /* Seul le span purement numerique est le badge visible ; celui destine
           aux lecteurs d'ecran contient du texte, on n'y touche pas. */
        if (/^\s*\d+\s*$/.test(spans[s].textContent) && spans[s].textContent !== shown) {
          spans[s].textContent = shown;
        }
      }
    }
  }

  /* ---- Re-rendu ------------------------------------------------------------
     Le theme identifie chaque ligne du panier par sa POSITION : `data-index` est
     ecrit au rendu Liquid, puis envoye tel quel a /cart/change.js lors d'un
     changement de quantite ou d'une suppression. Ajouter ou retirer le bon hors
     de ce rendu decale donc toutes les positions, et Shopify repond
     « Le paramètre line n'est pas valide. ».

     On demande les sections a /cart/update.js dans le meme appel et on les
     reinjecte, exactement comme le fait le theme apres /cart/change.js.
     ------------------------------------------------------------------------ */
  function targets() {
    var list = [];
    if (document.querySelector('cart-drawer .drawer__inner')) {
      list.push({ section: 'cart-drawer', into: 'cart-drawer .drawer__inner', from: '.drawer__inner' });
    }
    var items = document.getElementById('main-cart-items');
    if (items) {
      list.push({ section: items.dataset.id, into: '#main-cart-items .js-contents', from: '.js-contents' });
    }
    var footer = document.getElementById('main-cart-footer');
    if (footer) {
      list.push({ section: footer.dataset.id, into: '#main-cart-footer .js-contents', from: '.js-contents' });
    }
    list.push({ section: 'cart-icon-bubble', into: '#cart-icon-bubble', from: '.shopify-section' });
    return list;
  }

  function render(cart, list) {
    if (!cart || !cart.sections) return;
    for (var i = 0; i < list.length; i++) {
      var html = cart.sections[list[i].section];
      var into = document.querySelector(list[i].into);
      if (!html || !into) continue;
      var from = new DOMParser().parseFromString(html, 'text/html').querySelector(list[i].from);
      if (from) into.innerHTML = from.innerHTML;
    }
    /* Garde du theme : evite que CartDrawerItems.onCartUpdate() n'aille
       rechercher la section une seconde fois juste apres. */
    window.lsfDrawerRenderedAt = Date.now();

    /* Le Liquid rend le sous-total et les economies sous forme de marqueurs
       remplis par JavaScript, et le carrousel upsell doit etre reinstancie.
       Sans ce rappel, chaque ajout ou retrait du bon laissait le tiroir avec
       « ... » au sous-total et un bloc « Complétez votre commande » vide. */
    if (typeof window.lsfDrawerHydrate === 'function') window.lsfDrawerHydrate();
  }

  function sync(cart) {
    var want = wanted(cart);
    var updates = {};
    var change = false;

    for (var i = 0; i < IDS.length; i++) {
      var target = IDS[i] === want ? 1 : 0;
      if (countOf(cart, IDS[i]) !== target) {
        updates[IDS[i]] = target;
        change = true;
      }
    }

    if (!change) {
      paint(cart);
      return Promise.resolve(cart);
    }

    busy = true;
    var list = targets();
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: list.map(function (t) { return t.section; }).join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('/cart/update.js a repondu ' + r.status);
        return r.json();
      })
      .then(function (c) {
        busy = false;
        render(c, list);
        paint(c);
        return c;
      })
      .catch(function (e) {
        busy = false;
        log("ajout ou retrait du bon impossible", e);
        return null;
      });
  }

  function refresh() {
    if (busy && pending) return pending;
    pending = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(sync)
      .catch(function (e) {
        log('lecture du panier impossible', e);
        return null;
      });
    return pending;
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(refresh, 250);
  }

  /* ---- Paiement -----------------------------------------------------------
     Le bouton « Passer au paiement » soumet #CartDrawer-Form, qui contient un
     <input name="updates[]"> par ligne AFFICHEE. Notre bon etant ajoute hors du
     rendu du theme, ce tableau est plus court que le panier reel ; Shopify
     applique les quantites par position et supprime la ligne excedentaire,
     c'est-a-dire le bon. C'est ce qui s'est produit sur la commande #11844.

     On court-circuite donc cette soumission. Elle est un vestige du mode sans
     JavaScript : quantites, note et code promo sont deja enregistres cote
     serveur par les appels AJAX du theme. On se contente de terminer la
     synchronisation, puis d'aller au paiement.
     ------------------------------------------------------------------------ */
  function checkoutUrl() {
    var routes = window.Shopify && window.Shopify.routes;
    var root = (routes && routes.root) || '/';
    return root + 'checkout';
  }

  function onCheckout(e) {
    if (e.defaultPrevented || e.button) return;
    var el = e.target && e.target.closest ? e.target : null;
    var btn = el && el.closest('button[name="checkout"], input[type="submit"][name="checkout"]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var gone = false;
    function go() {
      if (gone) return;
      gone = true;
      window.location.href = checkoutUrl();
    }

    /* On ne retient jamais le client : au-dela de 2,5 s on part sans le bon
       plutot que de bloquer une vente. */
    window.setTimeout(go, 2500);

    /* La note du panier n'etant plus portee par le formulaire, on l'enregistre
       explicitement avant de quitter la page. */
    var note = document.querySelector('#CartDrawer-Note, #Cart-note, textarea[name="note"]');
    var saved = note
      ? fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note.value })
        }).catch(function (err) { log('note du panier non enregistree', err); })
      : Promise.resolve();

    window.clearTimeout(timer);
    saved.then(refresh).then(go, go);
  }

  function start() {
    refresh();

    /* Phase de capture : on passe avant le gestionnaire de soumission du theme. */
    document.addEventListener('click', onCheckout, true);

    /* Le theme redessine le tiroir via l'API Section Rendering. On n'observe
       que les ajouts/retraits de noeuds : paint() se contente d'ajouter une
       classe et de changer un texte, il ne peut donc pas reboucler ici. */
    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
    }
    var page = document.querySelector('.cart-items');
    if (page) {
      new MutationObserver(schedule).observe(page, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ==========================================================================
   LSF 21/09/2026 — MEGA-MENU DESKTOP : produits recommandes au survol.

   Le mega-menu du theme (sections/header.liquid) n'affiche que des liens et un
   visuel statique. Ici, survoler une categorie de niveau 2 charge les 4
   premiers produits de la collection correspondante et les affiche dans un
   panneau ajoute sous la liste.

   - Source : /collections/<handle>/products.json?limit=4 — l'ordre est celui
     de la collection, donc « recommande » suit le tri choisi dans l'admin.
   - Le panneau est insere DANS '.mega-menu__content', donc a l'interieur de
     <header-menu> : le 'focusout' de details-disclosure.js ne referme pas le
     menu quand la souris passe sur les produits.
   - Aucun fichier coeur du theme n'est modifie ; styles en section 9 de
     lsf-mobile-ux.css.
   ========================================================================== */
(function () {
  'use strict';

  var LIMIT = 4;
  var HOVER_DELAY = 120;
  var cache = {};

  function handleOf(href) {
    var m = /\/collections\/([^/?#]+)/.exec(href || '');
    if (!m) return '';
    /* On ignore les pages de collection filtrees ou « voir tout » generiques :
       elles restent de vraies collections, donc on les garde telles quelles. */
    return m[1];
  }

  function money(value) {
    var n = parseFloat(value);
    if (isNaN(n)) return '';
    return n.toFixed(2).replace('.', ',') + '\u00a0€';
  }

  function thumb(src) {
    if (!src) return '';
    /* Le CDN Shopify accepte le parametre 'width'. L'URL contient deja '?v='. */
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=320';
  }

  function skeleton(grid) {
    grid.textContent = '';
    for (var i = 0; i < LIMIT; i++) {
      var card = document.createElement('span');
      card.className = 'lsf-mm-card';
      var media = document.createElement('span');
      media.className = 'lsf-mm-card__media';
      card.appendChild(media);
      grid.appendChild(card);
    }
  }

  function draw(grid, products) {
    grid.textContent = '';
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var v = (p.variants && p.variants[0]) || {};
      var img = (p.images && p.images[0]) || null;

      var card = document.createElement('a');
      card.className = 'lsf-mm-card';
      card.href = '/products/' + p.handle;

      var media = document.createElement('span');
      media.className = 'lsf-mm-card__media';
      if (img) {
        var el = document.createElement('img');
        el.src = thumb(img.src);
        el.alt = '';
        el.width = 320;
        el.height = 320;
        el.loading = 'eager';
        media.appendChild(el);
      }
      card.appendChild(media);

      var title = document.createElement('span');
      title.className = 'lsf-mm-card__title';
      title.textContent = p.title;
      card.appendChild(title);

      var price = document.createElement('span');
      price.className = 'lsf-mm-card__price';
      price.textContent = money(v.price);
      if (v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(v.price)) {
        var old = document.createElement('s');
        old.textContent = money(v.compare_at_price);
        price.appendChild(old);
      }
      card.appendChild(price);

      grid.appendChild(card);
    }
  }

  function fetchProducts(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + LIMIT, {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        cache[handle] = (d && d.products) || [];
        return cache[handle];
      })
      .catch(function () { return []; });
  }

  /* Prepare un mega-menu : construit le panneau et branche les survols. */
  function equip(details) {
    var content = details.querySelector('.mega-menu__content');
    if (!content || content.querySelector('.lsf-mm-reco')) return;

    var links = [];
    var all = content.querySelectorAll('a.mega-menu__link--level-2');
    for (var i = 0; i < all.length; i++) {
      if (handleOf(all[i].getAttribute('href'))) links.push(all[i]);
    }
    if (!links.length) return;

    var panel = document.createElement('div');
    panel.className = 'lsf-mm-reco';
    panel.setAttribute('role', 'complementary');
    panel.setAttribute('aria-label', (window.lsfStrings && window.lsfStrings.mm_reco_label_html) || 'Produits recommandés de la catégorie survolée');
    panel.hidden = true;
    panel.innerHTML =
      '<div class="lsf-mm-reco__head">' +
      '<span class="lsf-mm-reco__eyebrow">' + ((window.lsfStrings && window.lsfStrings.mm_selection_html) || 'Notre sélection') + '</span>' +
      '<span class="lsf-mm-reco__cat"></span>' +
      '<a class="lsf-mm-reco__all" href="#">' + ((window.lsfStrings && window.lsfStrings.mm_see_collection_html) || 'Voir toute la collection →') + '</a>' +
      '</div><div class="lsf-mm-reco__grid"></div>';
    content.appendChild(panel);

    var cat = panel.querySelector('.lsf-mm-reco__cat');
    var seeAll = panel.querySelector('.lsf-mm-reco__all');
    var grid = panel.querySelector('.lsf-mm-reco__grid');
    var current = null;
    var timer = null;

    function show(link) {
      var handle = handleOf(link.getAttribute('href'));
      if (!handle || handle === current) return;
      current = handle;

      for (var j = 0; j < links.length; j++) links[j].classList.remove('lsf-mm-on');
      link.classList.add('lsf-mm-on');

      cat.textContent = link.textContent.trim();
      seeAll.href = link.getAttribute('href');
      panel.hidden = false;

      if (!cache[handle]) {
        panel.classList.add('lsf-mm-reco--loading');
        skeleton(grid);
      }

      fetchProducts(handle).then(function (products) {
        /* Une autre categorie a pu etre survolee pendant la requete. */
        if (current !== handle) return;
        panel.classList.remove('lsf-mm-reco--loading');
        if (!products.length) {
          panel.hidden = true;
          return;
        }
        draw(grid, products);
      });
    }

    for (var k = 0; k < links.length; k++) {
      (function (link) {
        link.addEventListener('mouseenter', function () {
          window.clearTimeout(timer);
          timer = window.setTimeout(function () { show(link); }, HOVER_DELAY);
        });
        link.addEventListener('mouseleave', function () {
          window.clearTimeout(timer);
        });
        /* Navigation clavier : Tab sur la categorie affiche aussi le panneau. */
        link.addEventListener('focus', function () { show(link); });
      })(links[k]);
    }

    /* A l'ouverture du menu, on affiche deja la premiere categorie : le
       panneau n'est jamais vide et sa hauteur ne saute pas au premier survol. */
    details.addEventListener('toggle', function () {
      if (details.open) show(links[0]);
    });
    if (details.open) show(links[0]);
  }

  function start() {
    /* En dessous de 990px le theme bascule sur le tiroir burger et
       '.header__inline-menu' n'est plus affiche : rien a equiper. */
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    var menus = document.querySelectorAll('.header__inline-menu details.mega-menu');
    for (var i = 0; i < menus.length; i++) equip(menus[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ==========================================================================
   LSF 21/09/2026 — RECHERCHE : SORTIR LA MODALE DE L'EN-TETE

   '#lsf-sb-modal' (snippets/lsf-search-bar.liquid) est rendu dans l'en-tete.
   '.header-wrapper' porte un 'backdrop-filter' (assets/base.css l.2305), ce
   qui en fait un BLOC CONTENEUR pour tout descendant en 'position: fixed'.
   Le 'inset: 0' de la modale se resolvait donc sur la boite de l'en-tete et
   non sur la fenetre : le voile '.lsf-sb-backdrop' ne grisait que la bande de
   l'en-tete, la page restait lisible sous le panneau et la zone de fermeture
   au clic exterieur etait reduite a presque rien.

   On deplace la modale en enfant direct de <body>. Les ecouteurs poses par le
   snippet survivent au deplacement (appendChild ne les detache pas) et le
   <style> inline reste en place, donc tout continue de fonctionner.
   On ajoute un ecouteur de secours : tout clic dans la modale mais en dehors
   de '.lsf-sb-panel' ferme la recherche.
   ========================================================================== */
(function () {
  'use strict';

  function modalEl() {
    return document.getElementById('lsf-sb-modal');
  }

  function onClick(e) {
    var modal = modalEl();
    if (!modal || !modal.classList.contains('lsf-open')) return;
    var t = e.target;
    /* Un clic sur le panneau (champ, categories, carte produit) ne ferme rien. */
    if (t && typeof t.closest === 'function' && t.closest('.lsf-sb-panel')) return;
    var close = document.getElementById('lsf-sb-close');
    if (close) close.click();
  }

  function start() {
    var modal = modalEl();
    if (!modal) return;
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    modal.addEventListener('click', onClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ==========================================================================
   LSF 21/09/2026 — RECHERCHE : PRODUITS PAR COLLECTION AU SURVOL

   Dans la modale de recherche, la colonne « Catégories » n'etait qu'une liste
   de liens : la grille « Produits recommandes » restait figee sur les
   best-sellers. Au survol d'une categorie (desktop, pointeur fin), on remplace
   la grille par les 8 premiers produits de la collection correspondante, via
   /collections/<handle>/products.json. Le clic continue d'ouvrir la collection.

   La collection « Up-sell » (usage interne) est retiree de la liste.

   Le contenu d'origine est memorise et restaure a la fermeture de la modale.
   Les cartes sont construites avec les APIs du DOM et 'textContent' : aucune
   donnee produit n'est injectee via innerHTML.
   ========================================================================== */
(function () {
  'use strict';

  var HIDE = ['up-sell'];
  var LIMIT = 8;
  var DELAY = 120;
  var cache = {};
  var timer = null;
  var current = '';
  var base = null;
  var preset = null;
  var seeAll = null;

  function handleOf(href) {
    var m = /\/collections\/([^/?#]+)/.exec(href || '');
    return m ? m[1] : '';
  }

  function money(value) {
    var n = parseFloat(value);
    return isNaN(n) ? '' : n.toFixed(2).replace('.', ',') + '\u00a0€';
  }

  function card(p) {
    var v = (p.variants && p.variants[0]) || {};
    var price = parseFloat(v.price);
    var cmp = parseFloat(v.compare_at_price);
    var sale = !isNaN(cmp) && cmp > price;

    var a = document.createElement('a');
    a.className = 'lsf-sb-card';
    a.href = '/products/' + p.handle;

    var media = document.createElement('div');
    media.className = 'lsf-sb-card-img';
    var src = (p.images && p.images.length && p.images[0].src) || '';
    if (src) {
      var img = document.createElement('img');
      img.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=460';
      img.alt = p.title || '';
      img.loading = 'lazy';
      media.appendChild(img);
    }
    if (sale) {
      var bdg = document.createElement('span');
      bdg.className = 'lsf-sb-card-bdg';
      bdg.textContent = '-' + Math.round((1 - price / cmp) * 100) + '%';
      media.appendChild(bdg);
    }
    a.appendChild(media);

    var body = document.createElement('div');
    body.className = 'lsf-sb-card-body';

    var name = document.createElement('p');
    name.className = 'lsf-sb-card-name';
    name.textContent = p.title || '';
    body.appendChild(name);

    var stars = document.createElement('div');
    stars.className = 'lsf-sb-stars';
    var sv = document.createElement('span');
    sv.className = 'lsf-sb-stars-val';
    sv.textContent = '★★★★★';
    stars.appendChild(sv);
    body.appendChild(stars);

    var prices = document.createElement('div');
    prices.className = 'lsf-sb-card-prices';
    var now = document.createElement('span');
    now.className = 'lsf-sb-price';
    now.textContent = money(v.price);
    prices.appendChild(now);
    if (sale) {
      var was = document.createElement('span');
      was.className = 'lsf-sb-was';
      was.textContent = money(v.compare_at_price);
      prices.appendChild(was);
    }
    body.appendChild(prices);

    a.appendChild(body);
    return a;
  }

  function parts() {
    var def = document.getElementById('lsf-sb-def');
    if (!def) return null;
    var head = def.querySelector('.lsf-sb-col-t');
    var grid = def.querySelector('.lsf-sb-cards');
    return head && grid ? { head: head, grid: grid } : null;
  }

  function mark(link) {
    var modal = document.getElementById('lsf-sb-modal');
    if (!modal) return;
    var all = modal.querySelectorAll('.lsf-sb-cat-link');
    for (var i = 0; i < all.length; i++) {
      if (all[i] === link) all[i].classList.add('lsf-sb-on');
      else all[i].classList.remove('lsf-sb-on');
    }
  }

  function render(title, products) {
    var p = parts();
    if (!p) return;
    p.head.textContent = title;
    p.grid.innerHTML = '';
    for (var i = 0; i < products.length; i++) p.grid.appendChild(card(products[i]));
  }

  function restore() {
    var p = parts();
    if (!p || !base) return;
    p.head.textContent = base.title;
    p.grid.innerHTML = base.html;
    current = '';
    /* La grille par defaut EST celle des best-sellers : la pastille reste donc
       allumee sur cette categorie (etat pre-selectionne, visible en mobile). */
    mark(preset);
    if (seeAll && preset) seeAll.href = preset.getAttribute('href') || '#';
  }

  function show(link) {
    var h = handleOf(link.getAttribute('href'));
    if (!h || h === current) return;
    current = h;
    mark(link);
    var label = (link.textContent || '').trim();
    if (seeAll) seeAll.href = link.getAttribute('href') || '#';

    if (cache[h]) {
      render(label, cache[h]);
      return;
    }
    fetch('/collections/' + encodeURIComponent(h) + '/products.json?limit=' + LIMIT, {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        cache[h] = (d && d.products) || [];
        /* Une reponse arrivee dans le desordre ne doit pas ecraser la categorie
           actuellement survolee. */
        if (current === h) render(label, cache[h]);
      })
      .catch(function () {
        if (current === h) current = '';
      });
  }

  function bind(link) {
    link.addEventListener('mouseenter', function () {
      /* Pointeur grossier (tactile) : on laisse le clic ouvrir la collection. */
      if (!window.matchMedia('(hover: hover)').matches) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { show(link); }, DELAY);
    });
    link.addEventListener('mouseleave', function () {
      window.clearTimeout(timer);
    });
    link.addEventListener('focus', function () { show(link); });
    link.addEventListener('click', function (e) {
      /* Desktop : le clic ouvre la collection, comme avant. */
      if (window.matchMedia('(hover: hover)').matches) return;
      /* Tactile : le tap selectionne la categorie et charge ses produits.
         La navigation vers la collection passe par le bouton « Voir tout ». */
      e.preventDefault();
      show(link);
    });
  }

  function start() {
    var modal = document.getElementById('lsf-sb-modal');
    if (!modal) return;
    var p = parts();
    if (!p) return;
    base = { title: p.head.textContent, html: p.grid.innerHTML };

    var links = modal.querySelectorAll('.lsf-sb-cat-link');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (HIDE.indexOf(handleOf(link.getAttribute('href'))) !== -1) {
        var li = link.closest('li');
        if (li && li.parentNode) li.parentNode.removeChild(li);
        continue;
      }
      bind(link);
    }

    /* Bouton « Voir tout » : ouvre la collection actuellement selectionnee.
       Insere a cote du titre de la grille, donc epargne par restore() qui ne
       reecrit que le titre et le contenu de la grille. */
    seeAll = document.createElement('a');
    seeAll.className = 'lsf-sb-all';
    seeAll.textContent = (window.lsfStrings && window.lsfStrings.sb_see_all_html) || 'Voir tout →';
    p.head.parentNode.insertBefore(seeAll, p.head.nextSibling);

    /* Best-Sellers pre-selectionne : c'est le contenu de la grille par defaut. */
    preset = modal.querySelector('.lsf-sb-cat-link[href*="/collections/best-sellers"]')
      || modal.querySelector('.lsf-sb-cat-link');
    mark(preset);
    if (preset) seeAll.href = preset.getAttribute('href') || '#';

    /* A la fermeture, on remet les produits recommandes d'origine. */
    new MutationObserver(function () {
      if (!modal.classList.contains('lsf-open')) restore();
    }).observe(modal, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

